<ng-container *ngIf="formControl.touched && formControl.invalid && formControl.errors[key]">
    <div class="text-danger" [ngSwitch]="key">
        <span *ngSwitchCase="'required'">This field is required</span>
    </div>
</ng-container>
